import { hasCustomRoles } from './hasCustomRoles';
import type { Member } from './types';

export function isOwner(member: Member) {
  return !hasCustomRoles(member) && member.role === 'owner';
}
